import { FaqSection } from './FrequentlyAskedQuestions.styles';
import Question from './Question';
import questionAndAnswers from './questionsAndAnswers';

export default function FrequentlyAskedQuestions() {
  return (
    <FaqSection>
      <div className="grid gap-xl">
        <h2 className="text-text-strong t-heading-2xl md:t-heading-3xl">
          Frequently Asked Questions
        </h2>
        <p className="text-text-default t-body-lg">
          Have more questions about the EV Tax Credit? We’ve got you covered.
        </p>
      </div>
      <ul>
        {questionAndAnswers.map(({ question, answer }) => (
          <Question key={question} question={question} answer={answer} />
        ))}
      </ul>
    </FaqSection>
  );
}
